module.exports = __webpack_public_path__ + "assets/img/Logitech-G-3-Social-Static-Ad-w960.ad5696f1.webp";